










import AbpBase from "@/lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import util from "@/lib/util";
@Component({})
export default class extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Object, default: {} }) data: any;
  title="";
  copyColumn = [
    {
    title: "患者姓名",
    key: "PatientName",
    },
    {
    title: "随访内容",
    key: "FollowUpContent",
    }
  ];
  created() {
    this.title=this.data.Date+ "复制明细";
  }
  cancel() {
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/follow/followUpAppointment/copyDataDetailed.vue